import { Component, OnDestroy } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { DOCTORS } from '../../data/doctors.data';
import { Doctor } from '../../data/models';
import { SiteDoctor, SiteDoctorService } from '../../site-doctor.service';
import { SiteNavService } from '../../site-nav.service';

@Component({
  selector: 'ws-site-doctor-profile',
  templateUrl: './doctor-profile.component.html'
})
export class SiteDoctorProfileComponent implements OnDestroy {
  doctor: Doctor;
  dynamicDoctor: SiteDoctor;

  private readonly sub: Subscription;

  constructor(nav: SiteNavService, doctorService: SiteDoctorService) {
    this.sub = combineLatest(nav.page$, doctorService.doctors$).subscribe(([page]) => {
      const dynamic = doctorService.bySlug(page.slug);
      if (dynamic) {
        this.dynamicDoctor = dynamic;
        this.doctor = null;
        return;
      }
      const d = DOCTORS.find(x => x.slug === page.slug);
      if (d) { this.doctor = d; this.dynamicDoctor = null; }
    });
  }

  ngOnDestroy() { this.sub.unsubscribe(); }
}
